<template>
  <div class="row no-gutter relative">
    <div class>
      <div class="offer-padding">
        <legend class="h4">Oppsummering</legend>
        <p>
          Vennligst kontrollér at valgene og opplysningene dine stemmer.
          <br />
          <br />Etter innsendt skjema vil du få et digitalt tilbud på e-post med
          en gyldighet på 30 dager. <br />Tilbudet er <b>ikke bindende</b> og
          innsending av skjema er <b>helt uforpliktende</b>.
        </p>
        <MobilePriceDrilldown :expandable="false"></MobilePriceDrilldown>
        <OfferInformation class="offerInformation"></OfferInformation>

        <div class="highlighted-box-container">
          <div class="highlighted-box">
            <h2 class="h6">Estimert årlig produksjon</h2>
            <h2 class="h5">{{ panel.kwtAar | Thousands }} kwh</h2>
          </div>
          <div class="highlighted-box">
            <h2 class="h6">Estimert årlig besparelse</h2>
            <h2 class="h5">{{ (panel.kwtAar * elPriceKWh) | Money }}</h2>
          </div>
        </div>

        <div v-if="!isOfferSubmitted" class="row" style="margin-top: 3rem">
          <div class="col-s-10">
            <fieldset class="form__field-group">
              <ul class="form__field--checkbox">
                <li>
                  <label>
                    <input
                      type="checkbox"
                      name="form-agreedToTerms"
                      v-model="agreedToTerms"
                    />
                    <span>Samtykke</span>
                  </label>
                </li>
              </ul>
              <p>
                Jeg samtykker til at Haugaland Kraft lagrer informasjonen jeg
                har gitt for å kunne gi meg et tilbud. Det er mulig at endelig
                tilbud vil avvike fra estimatet ovenfor. Kredittsjekk
                gjennomføres rutinemessig.
                <a
                  href="#"
                  style="margin-top: 2em; display: inline-block;"
                  @click="showModal = true"
                  >Se forutsetninger og betingelser</a
                >
              </p>
            </fieldset>
          </div>
        </div>

        <div v-if="!isOfferSubmitted" class="row" style="margin-top: 1rem">
          <div class="col-s-10">
            <fieldset class="form__field-group">
              <ul class="form__field--checkbox">
                <li>
                  <label>
                    <input
                      type="checkbox"
                      name="form-agreedToMarketing"
                      v-model="agreedToMarketing"
                    />
                    <span>Nyhetsbrev</span>
                  </label>
                </li>
              </ul>
              <p>
                Jeg er såpass interessert at jeg ønsker å bli oppdatert via
                e-post (slik at jeg kan briljere i lunsjen).
              </p>
            </fieldset>
          </div>
        </div>

        <hr />
        <a href="https://hkraft.no/solkraft/skybatteri/" target="_blank">
        <div class="skybatteri"></div>
        </a>
        <h2 class="h6">Vi tilbyr Skybatteri med ubegrenset lagring</h2>
        <p>
          Når du overproduserer solkraft kan du lagre dette i
          <a href="https://hkraft.no/solkraft/skybatteri/" target="_blank">
            skybatteriet</a
          >
          og bruke strømmen senere.
        </p>

        <div class="row" style="margin-top: 1rem">
          <div class="col-s-10">
            <fieldset class="form__field-group">
              <div v-if="isOfferSubmitted" style="margin-top: 3em">
                <h2 class="h4">Takk for din forespørsel!</h2>
                <p>Du vil motta tilbudet på e-post innen et par minutter.</p>

                <button
                  class="btn btn-solid btn-hk-blue-deep btn-arrow"
                  type="button"
                  @click="reset"
                >
                  Beregn nytt tilbud
                </button>
              </div>
            </fieldset>
          </div>
        </div>

        <div
          class="modal"
          :class="{ 'is-visible': showModal }"
          id="modal1"
          @keyup.esc="showModal = false"
          @click.self="showModal = false"
        >
          <div class="modal-dialog">
            <header class="modal-header">
              Forutsetninger for tilbud
              <button
                type="button"
                class="close-modal"
                aria-label="close modal"
                @click="showModal = false"
              >
                ✕
              </button>
            </header>
            <section class="modal-content">
              <legend class="h5">Forutsetninger for tilbud</legend>
              <p>
                Tilbudet som er generert baserer seg på kundes valg og
                offentlige kartdata. Vi gjør oppmerksom på at tilbudet vil kunne
                endres dersom det er vesentlig forskjell mellom informasjon gitt
                fra kartverk og kunde sammenlignet med faktiske forhold på
                adressen.
              </p>
              <p>
                Tilbudet omfatter montering av komplett solcelleanlegg på
                bygning tilkoblet strømnettet.
              </p>
              <p>
                Solcelleanleggets komponenter omfatter solcellepanel,
                vekselretter, festesystem og kabler.
              </p>

              <ul>
                <li>
                  Taktype opplyst av Kunde er benyttet som grunnlag for
                  prisberegningen.
                </li>
                <li>
                  Det forutsettes at tilstanden på Kundens takflate er egnet for
                  montering av solceller, og at strømforsyningen i aktuell
                  bygning har tilstrekkelig kapasitet for tilkobling av
                  tiltenkte solcelleanlegg.
                </li>
                <li>
                  Produksjonsestimat for forventet årsproduksjon benytter
                  beregningsmotoren til Solkart.no som kilde. Lokale skygger fra
                  vegetasjon eller bygninger er ikke hensyntatt i estimatet.
                </li>
              </ul>

              <p>
                Standard betingelser for integrert montasje (solceller som
                yttertak):
              </p>

              <ul>
                <li>
                  Prisen i tilbudet forutsetter at undertaket er ryddet, dvs
                  fritt for takstein / annet taktekke, ved avtalt
                  montasjetidspunkt.
                </li>
                <li>
                  I tilbudet forutsettes det at eksisterende taktekke kan
                  benyttes for å utgjøre tetting / overgang rundt
                  solcelleanlegget, med mindre andre løsninger er avtalt før
                  montasje.
                </li>
              </ul>

              <p>Standard betingelser for el-montasje *:</p>

              <ul>
                <li>
                  Installasjonen forutsetter spenningskvalitet innenfor
                  normalområde på 230V (207 V – 253 V) eller 400V (360V – 440V)
                  på strømnettet i bygningen der solcelleanlegget skal monteres.
                </li>
                <li>
                  Sikringsskapet i samme bygning som solcelleanlegget må ha
                  tilstrekkelig plass for ny kurs og tilkobling av denne.
                </li>
                <li>
                  Prisen i tilbudet fra Leverandør fordrer, om ikke annet er
                  skriftlig avtalt, at vekselretter kan monteres rett innenfor
                  eller utenfor yttervegg i samme rom som sikringsskap (inntil
                  ca 10 m kabellengde), uten behov for hulltaking bortsett fra
                  evt. i yttervegg, og i samme bygg som solcelleanlegget.
                  Kabling mellom solcellepaneler og vekselretter utføres som
                  standard med korteste veg, utenpå vegg.
                </li>
                <li>
                  Videre forutsettes det at det er enkel tilgang til føringsvei
                  for kabel og arbeid i sikringsskap, dvs. at det er ryddet
                  plass (ca 1 m fra kabelføringsvei og rundt sikringsskap) for
                  tilgang til elektriker-arbeid langs føringsvei for kabel og
                  inn til sikringsskap ved montasje.
                </li>
              </ul>

              <p>
                * Avvik fra standard betingelser kan medføre ekstra kostnader
                for Kunde på grunn av økt arbeidstid og økte utstyrskostnader.
                Alternative løsninger for installasjon og evt tillegg i pris vil
                avtales med kunde i forkant av installasjonen.
              </p>
              <p>
                Les mer om våre
                <a
                  href="https://solkraft.hkraft.no/vilkar-og-betingelser/"
                  target="_blank"
                  >vilkår og betingelser</a
                >
                for solkraftkunder.
              </p>
            </section>
          </div>
        </div>

        <div
          class="modal"
          :class="{ 'is-visible': showSuccessModal }"
          id="modal1"
          @keyup.esc="showSuccessModal = false"
          @click.self="showSuccessModal = false"
        >
          <div class="modal-dialog">
            <header class="modal-header">
              Takk!
              <button
                type="button"
                class="close-modal"
                aria-label="close modal"
                @click="showSuccessModal = false"
              >
                ✕
              </button>
            </header>
            <section class="modal-content">
              <legend class="h4">Takk for din forespørsel!</legend>
              <p>Du vil motta tilbudet på e-post innen et par minutter.</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store';

import MobilePriceDrilldown from './MobilePriceDrilldown';
import OfferInformation from './OfferInformation';

import Money from '../filters/Money';
import Thousands from '../../common/filters/Thousands';

export default {
  name: 'Summary',
  components: {
    MobilePriceDrilldown,
    OfferInformation,
  },
  filters: {
    Thousands,
    Money,
  },
  data() {
    return {
      showModal: false,
      showSuccessModal: false,
    };
  },
  methods: {
    reset() {
      store.commit('resetOfferSubmission');
    },
  },
  computed: {
    elPriceKWh() {
      return store.state.elPriceKWh;
    },
    panel() {
      return store.state.panelsVal;
    },
    agreedToMarketing: {
      get() {
        return store.state.CustomerInformation.agreedToMarketing;
      },
      set(value) {
        store.state.CustomerInformation.agreedToMarketing = value;
        store.commit('setCustomerInformation', {
          CustomerInformation: store.state.CustomerInformation,
        });
      },
    },
    agreedToTerms: {
      get() {
        return store.state.CustomerInformation.agreedToTerms;
      },
      set(value) {
        store.state.CustomerInformation.agreedToTerms = value;
        store.commit('setCustomerInformation', {
          CustomerInformation: store.state.CustomerInformation,
        });
      },
    },
    isOfferSubmitted() {
      return store.state.isOfferSubmitted;
    },
  },
  watch: {
    isOfferSubmitted() {
      this.showSuccessModal = this.isOfferSubmitted;
    },
  },
};
</script>

<style scoped>
.offer-padding {
  padding-bottom: 2em;
  margin-top: 8rem;
}

@media (min-width: 48rem) {
  .offer-bg {
    background-image: url('../assets/bg.jpg');
    background-size: cover;
    min-height: 250px;
  }
}

.offerInformation >>> .summary {
  background-color: #fff;
}

.offerInformation >>> .summary__line {
  border-color: #003451;
}

.highlighted-box-container {
  display: flex;
  justify-content: space-between;
  margin-top: 3rem;
}

.highlighted-box {
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  border-radius: 0rem;
  text-align: center;
  width: 48%;
  height: 10rem;
  text-transform: uppercase;
}
.highlighted-box::after {
  content: '';
  background-image: url('../assets/bg_paper_yellow.jpg');
  background-size: auto;
  background-repeat: repeat;
  border-radius: 0rem;
  opacity: 0.9;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
}

.highlighted-box .h5,
.highlighted-box .h6 {
  margin: 0.25rem 0;
  font-weight: 700;
}

.highlighted-box .h5 {
  font-size: 18px;
}

.highlighted-box .h6 {
  font-size: 12px;
}

.form__field--checkbox label {
  line-height: 0;
}

.form__field--checkbox ~ p {
  font-size: 15px;
}

input[type='checkbox'] {
  margin: 0;
  outline: none !important;
}

input[type='checkbox'] + span {
  font-size: 1.2em;
  font-weight: 600;
}

input[type='checkbox'] + span:before {
  border-color: #003451;
}

input[type='checkbox']:checked + span:before {
  background-color: #003451 !important;
  left: -2.4em;
}

.skybatteri {
  width: 48%;
  background-image: url('../assets/Skybatteri-logo.png');
  background-size: contain;
  background-repeat: no-repeat;
  margin-top: 2rem;
  border: 0 !important;
  height: 8rem;
  border-image-width: 0;
}

@media (max-width: 48em) {
  .skybatteri {
    width: 100%;
  }
}
</style>
